// Estilos del generador de etiquetas de juguetes (antes .p-gen-* en
// portal.css), compartidos por la pantalla y sus campos.

// Formulario y etiqueta lado a lado; una columna debajo de 992px
export const grilla = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
  gap: "1.25rem",
  alignItems: "start",
  "@media (max-width: 991px)": { gridTemplateColumns: "minmax(0, 1fr)" }
};

// En web la etiqueta queda a la vista mientras se recorren las preguntas
export const modelo = {
  position: "sticky",
  top: 84,
  minWidth: 0,
  "@media (max-width: 991px)": { position: "static" }
};

// Una pregunta con su control a la derecha (sin líneas entre preguntas)
export const fila = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "0.6rem 0"
};

// Fila con un selector o un texto: en pantallas angostas el control baja
// debajo de la pregunta y toma todo el ancho
export const filaControl = {
  ...fila,
  "@media (max-width: 575px)": { flexDirection: "column", alignItems: "stretch", gap: "0.4rem" }
};

export const pregunta = {
  flex: 1,
  minWidth: 0,
  fontSize: "0.9rem",
  color: "rgba(44, 44, 44, 1)",
  cursor: "pointer",
  lineHeight: 1.35
};

export const control = {
  flex: "0 1 240px",
  minWidth: 0,
  "@media (max-width: 575px)": { flex: "none", width: "100%" }
};

// Título de cada grupo de preguntas
export const grupo = {
  margin: "1.25rem 0 0.25rem",
  fontSize: "0.72rem",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--grisTextos)"
};
